import React, { useState, createContext, useContext } from "react";
import api from "../../Utils/api";

const apiPath = {
  getJobsForConsultant: "/jobnproject/getjobsforconsultant",
  fetchJobDetails: "/jobnproject/getjobbyid",
  getAllSkills: "/jobnproject/getallskills",
  getTimesheetByWeek: "/timesheet/gettimesheetbyweeks",
};

const nullFn = () => null;
const promiseFn = () => new Promise();
const TimesheetContext = createContext({
  loading: false,
  timesheet: [],
  fetchTimesheetByWeek: promiseFn,
  downloadTimesheetasPdf: nullFn,
});

export const useCommonTimesheetProvider = () => useContext(TimesheetContext);
const TimesheetProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [timesheet, setTimesheet] = useState(null);

  const fetchTimesheetByWeek = async (jobId, startDate, endDate) => {
    setLoading(true);
    try {
      const res = await api.get(apiPath.getTimesheetByWeek, {
        params: {
          jobId,
          userId: localStorage.getItem("userId"),
          start_date: startDate,
          end_date: endDate,
        },
      });
      if (res.status === 200 && res.data?.success) {
        setTimesheet(res.data.result);
        return res.data.result;
      } else {
        throw new Error("Error occurred while fetching skills");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const downloadTimesheetasPdf = (blob, startDate, endDate) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${startDate}_${endDate}.pdf`);
    document.body.appendChild(link);
    link.click();
  };
  const value = {
    loading,
    timesheet,
    fetchTimesheetByWeek,
    downloadTimesheetasPdf,
  };

  return (
    <TimesheetContext.Provider value={value}>
      {children}
    </TimesheetContext.Provider>
  );
};

export default TimesheetProvider;
